import { CashRounding } from "../modules/settings/components/PaymentMethodForm/types";
import { roundCashNearest05, roundCashNearest10 } from "./round-cash";

export function roundToDenominations(
  money: number,
  cashRounding?: CashRounding | null
): string[] {
  if (money === 0 || !money) {
    return ["0.00"];
  }

  const result = new Set<string>();
  // Default to ROUND_TO_05 if undefined or null
  const rounding = cashRounding ?? CashRounding.ROUND_TO_05;

  switch (rounding) {
    case CashRounding.ROUND_TO_10:
      result.add(roundCashNearest10(money).toFixed(2));
      result.add((Math.round(money / 10) * 10).toFixed(2));
      result.add((Math.ceil(money / 10) * 10).toFixed(2));
      break;

    case CashRounding.NONE:
      result.add(money.toFixed(2)); // just return as-is, with 2 decimals
      break;

    case CashRounding.ROUND_TO_05:
    default:
      result.add(roundCashNearest05(money).toFixed(2));
      result.add((Math.round(money / 10) * 10).toFixed(2));
      // Like in the Australian version, can also add some representative denominations
      [5, 10, 20, 50, 100].forEach((den) => {
        const roundedUp = Math.ceil(money / den) * den;
        // Only add if roundedUp is at least as much as money
        if (roundedUp >= money) {
          result.add(roundedUp.toFixed(2));
        }
      });
      result.add((Math.ceil(money / 100) * 100).toFixed(2));
      break;
  }

  // Take at most 5, filter for >= money
  return [...result].slice(0, 5).filter((value) => parseFloat(value) >= money);
}
